// Array with objects with 'name' as key, combined with sort method -> reorder the objects in alphabetical order
// example: array.sort(orderAlphabetical)
export function orderAlphabetical(
  a: { name?: string; title?: string },
  b: { name?: string; title?: string }
): number {
  let nameA = ''
  let nameB = ''
  if (a.name) {
    nameA = a.name.toUpperCase()
  } else if (a.title) {
    nameA = a.title.toUpperCase()
  }

  if (b.name) {
    nameB = b.name.toUpperCase()
  } else if (b.title) {
    nameB = b.title.toUpperCase()
  }
  let comparison = 0
  if (nameA > nameB) {
    comparison = 1
  } else if (nameA < nameB) {
    comparison = -1
  }
  return comparison
}

export function orderByOrder(a: { order: number }, b: { order: number }): number {
  const orderA = a.order
  const orderB = b.order
  let comparison = 0
  if (orderA > orderB) {
    comparison = 1
  } else if (orderA < orderB) {
    comparison = -1
  }
  return comparison
}

export function orderFilesAlphabetical(a: { name: string }, b: { name: string }): number {
  const nameA = a.name.substring(15).toUpperCase()
  const nameB = b.name.substring(15).toUpperCase()
  let comparison = 0
  if (nameA > nameB) {
    comparison = 1
  } else if (nameA < nameB) {
    comparison = -1
  }
  return comparison
}

export function orderFilesByFileEnding(a: { name: string }, b: { name: string }): number {
  const nameA = a.name.lastIndexOf('.')
  const nameB = b.name.lastIndexOf('.')
  let comparison = 0
  if (nameA > nameB) {
    comparison = 1
  } else if (nameA < nameB) {
    comparison = -1
  }
  return comparison
}

export function orderOnLevel(
  a: { properties: { level?: string | number; name?: string } },
  b: { properties: { level?: string | number; name?: string } }
): number {
  const levela = a.properties.level ? a.properties.level : a.properties.name
  const levelb = b.properties.level ? b.properties.level : b.properties.name
  const level1 = parseFloat(levela as string)
  const level2 = parseFloat(levelb as string)
  if (level1 === level2) return 0
  return level1 > level2 ? 1 : -1
}
